<div class="bg-main-container">
  <div class="p-3 font-white">
    <div class="d-flex justify-content-between">
      <div class="fs-16 fw-bold font-white mb-3">Package Details</div>
    </div>
    <div class="border-bottom mb-2 mt-2"></div>
    <div class="mt-4 row">
      @if(packageDetails) {
      <div class="col-md-3 col-12 mb-2">
        <div class="fs-12 fw-normal font-gray-opacity">Package Name</div>
        <div class="fs-14 fw-bold">{{ packageDetails.PackageName }}</div>
      </div>
      <div class="col-md-3 col-12 mb-2">
        <div class="fs-12 fw-normal font-gray-opacity">Start Date</div>
        <div class="fs-14 fw-bold">{{ packageDetails.StartTime | date : "dd/MM/yyyy" }}</div>
      </div>
      <div class="col-md-3 col-12 mb-2">
        <div class="fs-12 fw-normal font-gray-opacity">End Date</div>
        <div class="fs-14 fw-bold">{{ packageDetails.EndTime | date : "dd/MM/yyyy" }}</div>
      </div>
      <div class="col-md-3 col-12 mb-2">
        <div class="fs-12 fw-normal font-gray-opacity">Duration</div>
        <div class="fs-14 fw-bold">{{ packageDetails.Duration }} Month ({{ packageDetails.DurationInDays }} Days)</div>
      </div>

      <div class="col-md-3 col-12 mb-2">
        <div class="fs-12 fw-normal font-gray-opacity">Renewal Amount</div>
        <div class="fs-14 fw-bold">₹ {{ packageDetails.RenewAmount }}</div>
      </div>
      @if(packageDetails.AreaDetails){
      <div class="col-md-3 col-12 mb-2">
        <div class="fs-12 fw-normal font-gray-opacity">Areas</div>
        <div class="mt-2">
          <span class="center-chip-brown">
            {{ packageDetails.AreaDetails.AreaName }}
          </span>
        </div>
      </div>
      }
      <div class="border-bottom mt-3 mb-3"></div>
      <div class="fw-bold fs-14 mb-2">Amount Breakdown</div>
      <div class="d-flex justify-content-between mb-1">
        <div class="fs-12 font-gray-opacity fw-normal">Amount</div>
        <div class="fs-12 font-gray-opacity fw-normal">₹ {{ packageDetails.Amount }}</div>
      </div>
      <!-- <div class="d-flex justify-content-between mb-1">
        <div class="fs-12 font-gray-opacity fw-normal">CGST</div>
        <div class="fs-12 font-gray-opacity fw-normal">₹ {{ packageDetails.CGST }}</div>
      </div>
      <div class="d-flex justify-content-between mb-1">
        <div class="fs-12 font-gray-opacity fw-normal">SGST</div>
        <div class="fs-12 font-gray-opacity fw-normal">₹ {{ packageDetails.SGST }}</div>
      </div> -->
      <div class="d-flex justify-content-between mt-2">
        <div class="fs-14 fw-bold">Total</div>
        <div class="fs-14 fw-bold">₹ {{ packageDetails.FinalAmount }}</div>
      </div>
      <div class="d-flex gap-3 align-items-center mt-4 flex-wrap">
        <div class="form-check d-flex align-items-center gap-1">
          <input type="checkbox" class="form-check-input" id="activeCheck" [(ngModel)]="packageDetails.IsActive" [disabled]="true" />
          <label class="form-check-label font-white fs-14 fw-normal mt-1" for="activeCheck">Active</label>
        </div>
        <div class="form-check d-flex align-items-center gap-1">
          <input type="checkbox" class="form-check-input" id="upgradableCheck" [(ngModel)]="packageDetails.IsUpgradable" [disabled]="true" />
          <label class="form-check-label font-white fs-14 fw-normal mt-1" for="upgradableCheck">Upgradable</label>
        </div>
        <div class="form-check d-flex align-items-center gap-1">
          <input type="checkbox" class="form-check-input" id="renewableCheck" [(ngModel)]="packageDetails.IsRenewable" [disabled]="true" />
          <label class="form-check-label font-white fs-14 fw-normal mt-1" for="renewableCheck">Renewable</label>
        </div>
        <div class="form-check d-flex align-items-center gap-1">
          <input type="checkbox" class="form-check-input" id="transferableCheck" [(ngModel)]="packageDetails.IsTransferable" [disabled]="true" />
          <label class="form-check-label font-white fs-14 fw-normal mt-1" for="transferableCheck">Transferable</label>
        </div>
      </div>
      }
      <div class="mt-4 d-flex justify-content-end">
        <button class="close-btn px-4 py-2" (click)="onClose()">Close</button>
      </div>
    </div>
  </div>
</div>
